import {
  REPORTNOTIFS_GET,
  REPORTNOTIF_GET,
  REPORTNOTIF_DELETE,
} from './reduxConstant';

export const reportnotifsGet = (reportnotifs) => {
  return {
    type: REPORTNOTIFS_GET,
    payload: {
      reportnotifs,
    },
  };
};

export const reportnotifGet = (reportnotif) => {
  return {
    type: REPORTNOTIF_GET,
    payload: {
      reportnotif,
    },
  };
};

export const reportnotifDelete = (reportnotif) => {
  return {
    type: REPORTNOTIF_DELETE,
    payload: {
      reportnotif,
    },
  };
};
